<template>
    <footer class="xxxxx">
        <div class="container">
            <ul class="menu-list">
                <li v-for="(link, label, i) in data.footer_menu" :key="i">
                    <router-link v-bind:to="link" class="footer-menu-item1">
                        <span v-html="label"></span>
                    </router-link>
                </li>
            </ul>
            <div class="cstm-row">
                <h1><img src="/assets/img/footer/footer_logo.svg" alt="로고" /></h1>
                <div class="company-info">
                    <h2>(주)선명씨앤피</h2>
                    <ul>
                        <li>
                            본사 주소 : {{ data.contact_info?.contact_address }}
                            <span class="fs-11 px-2">|</span>
                            대표이사 : {{ data.company_info?.ceo_name }}
                        </li>
                        <li>
                            사업자번호 : {{ data.company_info?.biz_number }}
                            <span class="fs-11 px-2">|</span>
                            통신판매번호 : {{ data.company_info?.online_sales_license_number }}
                        </li>
                        <li>
                            개인정보관리 책임자 : {{ data.company_info?.privacy_manager }}
                            <span class="fs-11 px-2">|</span>
                            이메일 : {{ data.contact_info?.contact_email }}
                        </li>
                        <li>
                            연락처 : {{ data.contact_info?.contact_phone }}
                            <span class="fs-11 px-2">|</span>
                            팩스 : {{ data.contact_info?.contact_fax }}
                        </li>
                        <li>웹하드 : {{ data.company_info?.webhard_id }} / {{ data.company_info?.webhard_pw }}</li>
                    </ul>
                    <small v-html="data.copyright_text"></small>
                </div>
                <ul class="address-list">
                    <li>
                        <strong>서울본점(Offset Factory)</strong>
                        <address>(04555) 서울특별시 중구 충무로 29 아시아미디어타워 301호, 301-1호</address>
                    </li>
                    <li>
                        <strong>파주지점(Digital Factory)</strong>
                        <address>(10881) 경기도 파주시 광인사길 223</address>
                    </li>

                    <li>
                        <i>프리원 공식 채널 +</i>
                        <ul>
                            <li>
                                <a href="https://www.instagram.com/prione_official" target="_blank">
                                    <img src="/assets/img/footer/insta-icon.svg" alt="인스타그램" />
                                </a>
                            </li>
                            <li>
                                <a href="https://www.youtube.com/@iprione" target="_blank"><img src="/assets/img/footer/youtube-icon.svg" alt="유튜브" /></a>
                            </li>
                            <li>
                                <a href="https://pf.kakao.com/_lmexjX" target="_blank"><img src="/assets/img/footer/kakao-icon.svg" alt="카카오채널" /></a>
                            </li>
                            <!-- <li>
                                <a href=""><img src="/assets/img/footer/blog-icon.svg" alt="블로그" /></a>
                            </li> -->
                        </ul>
                    </li>
                </ul>
                <div class="cstm-select1">
                    <input value="Family Site" readonly />
                    <img class="arrow" src="/assets/img/footer/down-arrow.svg" />
                    <span></span>
                    <ul>
                        <li>
                            <a href="https://www.nemolab.co.kr/" target="_blank">
                                네모연구소
                                <img src="/assets/img/footer/share-icon.svg" alt="페이지 이동" />
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required, email } from 'vuelidate/lib/validators';

    export default {
        name: 'FooterType4',
        validations: {
            subscribeForm: {
                email: {
                    required,
                    email,
                },
            },
        },
        data: () => ({
            data: {},
            subscribeForm: {
                email: '',
            },
            subscribeFormLoading: false,
            isOpen: false,
        }),
        computed: {
            ...mapGetters('app', [
                'getHeaderSettings', //
                'getFooterSettings',
            ]),
            emailErrors() {
                const errors = [];
                if (!this.$v.subscribeForm.email.$dirty) return errors;
                !this.$v.subscribeForm.email.required && errors.push(this.$i18n.t('this_field_is_required'));
                !this.$v.subscribeForm.email.email && errors.push(this.$i18n.t('this_field_is_required_a_valid_email'));
                return errors;
            },
        },
        watch: {
            getFooterSettings: {
                immediate: true,
                handler(newVal, oldVal) {
                    if (this.$lds.isEmpty(newVal)) return;

                    this.data = newVal;
                },
            },
        },
        methods: {
            async subscribe() {
                this.$v.subscribeForm.$touch();
                if (this.$v.subscribeForm.$anyError) {
                    return;
                }
                this.subscribeFormLoading = true;
                const res = await this.call_api('post', 'subscribe', this.subscribeForm);

                this.snack({ message: res.data.message });
                this.subscribeFormLoading = false;
            },
        },
        mounted() {},
        beforeDestroy() {},
    };
</script>
<style lang="scss" scoped>
    .cstm-row {
        display: flex;
    }

    .cstm-select1 {
        width: 130px;
        position: relative;

        input {
            height: 30px;
            width: 100%;
            border: 1px solid #808080;

            font-size: 14px;
            line-height: 100%;
            vertical-align: middle;
            padding: 6px 10px 7px;

            color: #fcbe2e;

            cursor: pointer;
        }

        .arrow {
            position: absolute;
            top: 5px;
            right: 10px;
            cursor: pointer;
            pointer-events: none;
            vertical-align: top;
        }

        input:focus ~ .arrow {
            transform: rotate(180deg);
        }

        input:focus ~ span {
            display: block;
        }

        span {
            display: none;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 30px;
            cursor: pointer;
        }

        input:focus ~ ul {
            transform: scaleY(1);
        }

        ul {
            list-style: none;
            margin: 0;
            padding: 0;
            border: 1px solid #808080;
            border-top: 0;
            position: absolute;
            width: 100%;

            transform: scaleY(0);

            transition: transform 0s 0.15s;

            li {
                a {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 8px 10px;
                    cursor: pointer;

                    font-size: 14px;
                    line-height: 100%;

                    vertical-align: middle;
                    color: #fff;
                    text-decoration: none;
                }
            }
        }
    }

    footer {
        color: #fff;
        background: #000000;

        .container {
            padding: 70px 0;

            .menu-list {
                list-style: none;
                margin: 0 0 54px;
                padding: 0;
                display: flex;
                align-items: center;
                padding-left: 100px;

                li {
                    display: flex;
                    align-items: center;
                }

                li + li::before {
                    display: block;
                    margin: 0 40px;
                    content: '｜';
                    font-size: 0.5rem;
                }

                .footer-menu-item1 {
                    font-size: 14px;
                    color: #fff !important;
                }
            }

            h1 {
                margin: 0;
                width: 210px;

                img {
                    vertical-align: top;
                }
            }

            .company-info {
                width: 650px;

                h2 {
                    font-weight: 500;
                    font-size: 15px;
                    line-height: 100%;

                    vertical-align: middle;
                    margin-bottom: 16px;
                }

                ul {
                    margin: 0 0 30px;
                    padding: 0;
                    list-style: none;

                    li {
                        font-size: 14px;
                        line-height: 17px;
                        vertical-align: middle;
                        margin-bottom: 10px;

                        &:last-of-type {
                            margin-bottom: 0;
                        }
                    }
                }

                small {
                    font-size: 12px;
                    line-height: 100%;
                    vertical-align: middle;
                    color: #9c9c94;
                }
            }

            .address-list {
                margin: 0;
                padding: 0;
                list-style: none;
                width: 450px;

                & > li {
                    margin-bottom: 16px;

                    &:last-of-type {
                        margin-bottom: 0;
                    }

                    strong {
                        display: block;
                        font-weight: 500;
                        font-size: 15px;
                        line-height: 100%;
                        margin-bottom: 10px;
                    }

                    address {
                        font-size: 14px;
                        line-height: 100%;
                        display: block;
                        font-style: normal;
                    }

                    i {
                        display: block;
                        margin-bottom: 10px;

                        color: #ffd46b;
                        font-style: normal;

                        font-size: 12px;
                        line-height: 14px;
                    }

                    ul {
                        list-style: none;
                        margin: 0;
                        padding: 0;

                        display: flex;

                        li {
                            margin-right: 6px;

                            a,
                            img {
                                vertical-align: top;
                                display: inline-block;
                            }

                            &:last-of-type {
                                margin-right: 0;
                            }
                        }
                    }
                }
            }
        }
    }

    ::v-deep .footer-menu-item1 {
        font-weight: 500;
        font-size: 14px;
        line-height: 100%;
        vertical-align: top;
        color: #fff !important;
    }

    /* ===== 반응형: 태블릿 이하 ===== */
    @media (max-width: 959px) {
        footer .container {
            padding: 40px 16px;

            .menu-list {
                padding-left: 0;
                flex-wrap: wrap;
                gap: 8px;
                margin-bottom: 32px;

                li + li::before {
                    margin: 0 16px;
                }
            }

            .cstm-row {
                flex-wrap: wrap;
                gap: 28px;
            }

            h1 {
                width: 100%;
            }

            .company-info {
                width: 100%;
            }

            .address-list {
                width: 100%;
            }

            .cstm-select1 {
                width: 160px;
            }
        }
    }

    @media (max-width: 599px) {
        footer .container {
            padding: 32px 16px;

            .menu-list {
                gap: 4px;
                margin-bottom: 24px;

                li + li::before {
                    margin: 0 8px;
                }
            }

            .company-info ul li {
                font-size: 13px;
                line-height: 1.5;
                word-break: break-all;
            }
        }
    }
</style>